import script from "./TemplateFields.vue?vue&type=script&setup=true&lang=ts"
export * from "./TemplateFields.vue?vue&type=script&setup=true&lang=ts"

import "./TemplateFields.vue?vue&type=style&index=0&id=5ab3ffe4&lang=scss"

const __exports__ = script;

export default __exports__